import React from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import style from "./style.module.css";

export default class Captcha extends React.Component {
    _capthaRef = null;

    onChange = (value) => {
        const { input: { onChange } } = this.props;
        if (value) {
            onChange(value);
        }
        else {
            onChange("");
        }
    }

    onReset = () => {
        this.props.input.onChange("");
    }

    render() {
        return (
            <div className={`${style.recaptcha}`}>
                <ReCAPTCHA
                    sitekey={process.env.REACT_APP_GOOGLE_SITE_KEY}
                    onChange={this.onChange}
                    onExpired={this.onReset}
                    onErrored={this.onReset}
                    ref={r => this._capthaRef = r}
                />
            </div>
        )
    }
}